import { cn } from '@/platform/lib/utils';
import {
    ClockIcon,
    CurrencyEuroIcon,
    EnvelopeIcon,
    ExclamationTriangleIcon,
    PhoneIcon,
} from '@heroicons/react/24/outline';
import dayjs from 'dayjs';

const InvoiceIcon = ({ invoice }) => {
    if (invoice.payed_at) {
        return (
            <CurrencyEuroIcon
                className={cn(
                    'size-5',
                    invoice?.is_credit && 'text-red-600',
                    !invoice?.is_credit && 'text-green-600'
                )}
            />
        );
    }

    if (invoice.status == 1) {
        if (
            !invoice.payed_at &&
            dayjs().diff(invoice?.created_at, 'day') >=
                +invoice?.customer?.payment_interval + 16
        ) {
            return <PhoneIcon className='size-5 text-red-600' />;
        } else {
            <ExclamationTriangleIcon className='size-5 text-orange-600' />;
        }
    }

    if (invoice.mailed_at) {
        return <EnvelopeIcon className='size-5 text-gray-600' />;
    }

    return <ClockIcon className='size-5 text-gray-600' />;
};

export default InvoiceIcon;
